module.exports = __webpack_public_path__ + "6d757067ccc276327b1b444f1f3789cc.svg";